<template>
<div class="py-6 px-4 sm:px-6">

  <div>
    <div class="prose prose-sm prose-blue">
      <img src="@/assets/tutor-dbs-badge.png" class="w-28 float-right ml-4" />

      <h1 ref="title" class="text-2xl font-semibold mb-0">
        DBS Check
      </h1>
      <p class="lead mt-0">
        Reassure your prospective clients that you are a trustworthy choice.
      </p>
      
    </div>

    <transition name="fade" mode="out-in">

      <!-- Show Default (Intro), Valid, or Expired -->
      <Intro 
        v-if="screen === 'default' && !submitDbsFormVisible && !requestDbsFormVisible" 
        key="intro"
        @showSubmitDbsForm="showSubmitDbsForm"
        @showRequestDbsForm="showRequestDbsForm"
        @showRequirements="showRequirements"
      />
      <Valid
        v-else-if="screen === 'valid' && !submitDbsFormVisible && !requestDbsFormVisible"
        key="valid"
        :certificateNumber="$store.state.user.LatestDbsCertificateNumber"
        :certificateIssuedWhen="dayjs($store.state.user.LatestDbsDated).toDate()"
        :certificateValidUntil="certificateValidUntil.toDate()"
        @showSubmitDbsForm="showSubmitDbsForm"
        @showRequestDbsForm="showRequestDbsForm"
      />
      <Expired 
        v-else-if="screen === 'expired' && !submitDbsFormVisible && !requestDbsFormVisible"
        :certificateNumber="$store.state.user.LatestDbsCertificateNumber"
        :certificateIssuedWhen="dayjs($store.state.user.LatestDbsDated).toDate()"
        :certificateValidUntil="certificateValidUntil.toDate()"
        @showSubmitDbsForm="showSubmitDbsForm"
        @showRequestDbsForm="showRequestDbsForm"
      />
      

      <!-- Any of the above can also navigate to these screens -->
      <Submit
        v-else-if="submitDbsFormVisible"
        key="submit"
        @back="submitDbsFormVisible = false"
        @showRequirements="dbsModalOpen = true"
      />
      <Apply
        v-else-if="requestDbsFormVisible"
        key="apply"
        @back="requestDbsFormVisible = false"
        @showRequirements="dbsModalOpen = true"
      />
    </transition>

  </div>

  <DbsModalTutor
    v-if="dbsModalOpen"
    @close="dbsModalOpen = false"
  />

</div>
</template>

<script>
import dayjs from 'dayjs'
import DbsModalTutor from '../components/DbsModalTutor.vue'
import Intro from './DbsCheck/Intro.vue'
import Apply from './DbsCheck/Apply.vue'
import Submit from './DbsCheck/Submit.vue'
import Valid from './DbsCheck/Valid.vue'
import Expired from './DbsCheck/Expired.vue'

export default {
  components: { DbsModalTutor, Intro, Apply, Submit, Valid, Expired, },
  data() {
    return {
      submitDbsFormVisible: false,
      requestDbsFormVisible: false,
      dbsModalOpen: false,
      dayjs,
    }
  },
  computed: {
    screen() {
      if (!this.$store.state.user.LatestDbsDated) {
        return 'default'
      }
      else if (dayjs().isBefore(this.certificateValidUntil)) {
        return 'valid'
      }
      else {
        return 'expired'
      }
    },
    certificateValidUntil() {
      if (!this.$store.state.user.LatestDbsDated) return
      return dayjs(this.$store.state.user.LatestDbsDated).add(3, 'year')
    }
  },
  methods: {
    showSubmitDbsForm: function() {
      this.submitDbsFormVisible = true
      this.$refs.title.scrollIntoView({ block: 'start', behavior: 'smooth' })
    },
    showRequestDbsForm() {
      this.requestDbsFormVisible = true
      this.$refs.title.scrollIntoView({ block: 'start', behavior: 'smooth' })
    },
    showRequirements() {
      this.dbsModalOpen = true
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>